import { Box } from "@mui/material";

import { useInfo } from "@/context/InfoProvider/InfoProvider";

import { P1 } from "../Typography/Typography";

export const RetangleToggle = (props) => {
  const {
    isSelected,
    handleIsSelected,
    selectedLabel,
    unSelectedLabel,
    isNewUnSelectBkg = false,
  } = props;

  const { theme } = useInfo();

  let selectColor = isNewUnSelectBkg ? "#636363" : isSelected ? "#2F2F2F" : "white";
  let selectBackground = isSelected ? "white" : "#2F2F2F";
  let unSelectColor = isNewUnSelectBkg ? "#636363" : isSelected ? "white" : "#2F2F2F";
  let unSelectBackground = isSelected ? "#2F2F2F" : "white";

  if (theme?.mode === "light") {
    selectColor = isNewUnSelectBkg ? "#CECECE" : isSelected ? "white" : "#636363";
    selectBackground = isSelected ? "#636363" : "white";
    unSelectColor = isNewUnSelectBkg ? "#CECECE" : isSelected ? "#636363" : "white";
    unSelectBackground = isSelected ? "white" : "#636363";
  }

  return (
    <Box
      data-testcomp="Toggle"
      sx={{
        borderRadius: "5px",
        border: `2px solid ${theme?.mode === "dark" ? "white" : "#636363"}`,
        display: "flex",
        cursor: "pointer",
        position: "relative",
        marginLeft: "15px",
      }}
    >
      <Box
        onClick={() => handleIsSelected(isSelected)}
        data-teststate={isSelected ? "Selected" : "NotSelected"}
        sx={{
          display: "flex",
          alignItems: "center",
          background: selectBackground ? selectBackground : "transparent",
          borderTopLeftRadius: "3px",
          borderBottomLeftRadius: "3px",
          transition: "all 0.5s ease-out",
        }}
      >
        <P1 fSize={9} mrleft={9} mrright={9} mrtop={5} mrbottom={5} color={selectColor}>
          {selectedLabel}
        </P1>
      </Box>
      <Box
        onClick={() => handleIsSelected(!isSelected)}
        data-teststate={isSelected ? "NotSelected" : "Selected"}
        sx={{
          display: "flex",
          alignItems: "center",
          background: unSelectBackground ? unSelectBackground : "white",
          borderTopRightRadius: "3px",
          borderBottomRightRadius: "3px",
          transition: "all 0.5s ease-out",
        }}
      >
        <P1 fSize={9} mrleft={9} mrright={9} mrtop={5} mrbottom={5} color={unSelectColor}>
          {unSelectedLabel}
        </P1>
      </Box>
    </Box>
  );
};
